"use strict";

import "ttec-core-js";
import "ttec-dashboard-js";

(function() {

	var App = angular.module('pphhApp', ["ngMaterial", "smart-table", "ngMessages", "ngSanitize",
		"googlechart", "truncate", "ttecCore", 'ttecDashboard'])
		.constant("pphhEnv", angular.copy(window.__pphhEnv));

	App.factory("httpRequestInterceptor", ["pphhEnv", function(pphhEnv) {
		return {
			request: function(config) {

				var contextPath = pphhEnv.global.contextPath;
				var url = config.url;
				if (url.indexOf(contextPath + "/") < 0) {

					if (url.indexOf("/") != 0) {
						url = "/" + url;
					}

					config.url = contextPath + url;
				}

				if (config.method === "POST" || config.method === "DELETE") {
					config.headers[pphhEnv.global.csrfHeaderName] = pphhEnv.global.csrfToken;
				}

				return config;
			}
		};
	}]);

	App
		// Google Chart
		.config(["agcLibraryLoaderProvider", function(agcLibraryLoaderProvider) {
			agcLibraryLoaderProvider.setLoader("gstatic");
		}])
		.config(["agcGstaticLoaderProvider", "pphhEnv", function(agcGstaticLoaderProvider, pphhEnv) {
			agcGstaticLoaderProvider.setOption("language", pphhEnv.agcGstaticLoaderProvider.language);
		}])

		// $q
		.config(["$qProvider", function($qProvider) {
			$qProvider.errorOnUnhandledRejections(false);
		}])

		// $http
		.config(["$httpProvider", function($httpProvider) {
			$httpProvider.interceptors.push("httpRequestInterceptor");
		}])

		// smart-table
		.config(["stConfig", "pphhEnv", function(stConfig, pphhEnv) {
			stConfig.pagination.itemsByPage = 25;
			/*
			 * La configuración del retardo en la ordenación y la búsqueda se ha tenido que introducir
			   * con la actualización a la versión 2.1.11 del componente smart-table.
			 */
			stConfig.sort.delay = 100;
			stConfig.pipe.delay = 200;
			/*
			 * Se establece la URL absoluta del template de paginación incluyendo el contextPath
			 * para evitar que AngularJS resuelva el template desde el $templateCache interno de
			 * smart-table (que no incluye el span pagination_total) cuando el contextPath es vacío
			 * (entornos desplegados en el dominio raíz tipo https://pphh.domain.com/).
			 */
			stConfig.pagination.template = pphhEnv.global.contextPath + '/template/smart-table/pagination.html';
		}])

		// AngularJs Material	
		.config(["$mdDateLocaleProvider", "pphhEnv", function($mdDateLocaleProvider, pphhEnv) {

			$mdDateLocaleProvider.months = pphhEnv.mdDateLocaleProvider.months;
			$mdDateLocaleProvider.shortMonths = pphhEnv.mdDateLocaleProvider.shortMonths;
			$mdDateLocaleProvider.days = pphhEnv.mdDateLocaleProvider.days;
			$mdDateLocaleProvider.shortDays = pphhEnv.mdDateLocaleProvider.shortDays;
			$mdDateLocaleProvider.firstDayOfWeek = pphhEnv.mdDateLocaleProvider.firstDayOfWeek;
			$mdDateLocaleProvider.parseDate = pphhEnv.mdDateLocaleProvider.parseDate;
			$mdDateLocaleProvider.formatDate = pphhEnv.mdDateLocaleProvider.formatDate;
			$mdDateLocaleProvider.monthHeaderFormatter = pphhEnv.mdDateLocaleProvider.monthHeaderFormatter;
			$mdDateLocaleProvider.weekNumberFormatter = pphhEnv.mdDateLocaleProvider.weekNumberFormatter;
			$mdDateLocaleProvider.msgCalendar = pphhEnv.mdDateLocaleProvider.msgCalendar;
			$mdDateLocaleProvider.msgOpenCalendar = pphhEnv.mdDateLocaleProvider.msgOpenCalendar;
		}])

		.config(["ttecDasboardConfig", "pphhEnv", function(ttecDasboardConfig, pphhEnv) {
			ttecDasboardConfig.agcBar = angular.copy(pphhEnv.ttecDasboardConfig.agcBar);
			ttecDasboardConfig.agcPie = angular.copy(pphhEnv.ttecDasboardConfig.agcPie);
			ttecDasboardConfig.messages = angular.copy(pphhEnv.ttecDasboardConfig.messages);
		}])
		;

	App.directive("loading", ["$mdDialog", function($mdDialog) {

		var promise = null;

		return {
			restrict: "E",
			link: function(scope, element, attr) {
				var prop = "isLoading";
				if (attr.controller) {
					prop = attr.controller + "." + prop;
				}

				scope.$watch(prop, function(val) {
					if (val && !promise) {
						promise = $mdDialog.show({
							parent: angular.element(document.body),
							template:
								'<md-dialog loading>'
								+ '<md-dialog-content>'
								+ '<md-progress-linear md-mode="indeterminate"></md-progress-linear>'
								+ '</md-dialog-content>'
								+ '</md-dialog>',
							clickOutsideToClose: false,
							escapeToClose: false
						}).finally(function() {
							promise = null;
						});
					} else {
						$mdDialog.hide();
					}
				});
			}
		};
	}]);

	App.directive("ttecPercentage", ["$filter",
		function($filter) {
			return {
				require: "ngModel",
				restrict: "A",
				link: function($scope, element, attrs, ctrl) {
					ctrl.$formatters.push(function(modelValue) {
						if (modelValue != undefined) {
							return modelValue + " %";
						}
						return modelValue;
					});

					ctrl.$parsers.push(function(viewValue) {
						var newValue = null;
						if (viewValue.replace) {
							newValue = viewValue.replace(/(\s|%)/g, "");
						} else {
							newValue = viewValue;
						}

						var valid = !isNaN(newValue);
						if (valid) {
							var newPercentage = parseFloat(newValue);
							if (newPercentage < 0.0 || newPercentage > 100.0) {
								valid = false;
							}
						}
						if (!valid) {
							newPercentage = null;
						}
						ctrl.$setValidity(attrs.name, valid);
						return newPercentage;
					});
				}
			};
		}
	]);



	/**
	 * @ngdoc directive
	 * @name directive:validnif
	 * @description
	 * # validnif
	 */
	App.directive('validnif', function() {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, elem, attr, ctrl) {
				var validRegex = /^[XYZ]?([0-9]{7,8})([A-Z])$/i;
				var dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
				ctrl.$parsers.unshift(function(value) {
					var valid = false;
					if (value && value.length === 9) {
						value = value.toUpperCase().replace(/\s/, '');
						var niePrefix = value.charAt(0);
						switch (niePrefix) {
							case 'X':
								niePrefix = 0;
								break;
							case 'Y':
								niePrefix = 1;
								break;
							case 'Z':
								niePrefix = 2;
								break;
						}
						var valueTemp = niePrefix + value.substr(1);
						if (validRegex.test(valueTemp)) {
							valid = (valueTemp.charAt(8) === dniLetters.charAt(parseInt(valueTemp, 10) % 23));
						}
					}
					ctrl.$setValidity('validnif', valid);
					return valid ? value : undefined;
				});
			}
		};
	});

})();